define("checkout/components/proration", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "lodash", "moment", "checkout/utils/upgrade-downgrade", "shared/utils/object-methods", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _tracking, _emberConcurrency, _lodash, _moment, _upgradeDowngrade, _objectMethods, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@embroider/macros",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"lodash",0,"moment",0,"checkout/utils/upgrade-downgrade",0,"shared/utils/object-methods",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <span
    {{did-insert
      (perform this.calculateProration)
      @subscription
      @selectedSubscriptionPlan
      @additionalTeamMemberCount
      @additionalSocialSetCount
      @additionalAiCredits
      @couponId
      @savedAddress
      @cardCountry
      @hasTaxId
    }}
    {{did-update
      (perform this.calculateProration)
      @subscription
      @selectedSubscriptionPlan
      @additionalTeamMemberCount
      @additionalSocialSetCount
      @additionalAiCredits
      @couponId
      @savedAddress
      @cardCountry
      @hasTaxId
    }}
  >
    {{yield
      (hash
        immediateAmount=this.immediateAmount
        immediateAmountAfterTax=this.immediateAmountAfterTax
        futureAmount=this.futureAmount
        futureAmountAfterTax=this.futureAmountAfterTax
        futureDate=this.futureDate
        defaultFormat=this.defaultFormat
        userChange=this.userChange
        socialSetChange=this.socialSetChange
        aiCreditsChange=this.aiCreditsChange
        isAiCreditsChange=this.isAiCreditsChange
        isAiCreditsDowngrade=this.isAiCreditsDowngrade
        isUserChange=this.isUserChange
        isSocialSetChange=this.isSocialSetChange
        isAmountChange=this.isAmountChange
        isIntervalChange=this.isIntervalChange
        isIntervalDowngrade=this.isIntervalDowngrade
        isMissingTaxData=this.isMissingTaxData
        isPlanChange=this.isPlanChange
        isPlanDowngrade=this.isPlanDowngrade
        isSocialSetDowngrade=this.isSocialSetDowngrade
        isUserDowngrade=this.isUserDowngrade
        effectiveDate=this.effectiveDate
        aiCreditsEffectiveDate=this.aiCreditsEffectiveDate
        intervalEffectiveDate=this.intervalEffectiveDate
        planEffectiveDate=this.planEffectiveDate
        socialSetEffectiveDate=this.socialSetEffectiveDate
        userEffectiveDate=this.userEffectiveDate
        amountEffectiveDate=this.amountEffectiveDate
        isLoading=this.calculateProration.isRunning
        taxAmount=this.taxAmount
        taxRate=this.taxRate
        proratedTaxAmount=this.proratedTaxAmount
      )
    }}
  </span>
  */
  {
    "id": "DPpKvdiu",
    "block": "[[[11,1],[4,[38,0],[[28,[37,1],[[30,0,[\"calculateProration\"]]],null],[30,1],[30,2],[30,3],[30,4],[30,5],[30,6],[30,7],[30,8],[30,9]],null],[4,[38,2],[[28,[37,1],[[30,0,[\"calculateProration\"]]],null],[30,1],[30,2],[30,3],[30,4],[30,5],[30,6],[30,7],[30,8],[30,9]],null],[12],[1,\"\\n  \"],[18,10,[[28,[37,4],null,[[\"immediateAmount\",\"immediateAmountAfterTax\",\"futureAmount\",\"futureAmountAfterTax\",\"futureDate\",\"defaultFormat\",\"userChange\",\"socialSetChange\",\"aiCreditsChange\",\"isAiCreditsChange\",\"isAiCreditsDowngrade\",\"isUserChange\",\"isSocialSetChange\",\"isAmountChange\",\"isIntervalChange\",\"isIntervalDowngrade\",\"isMissingTaxData\",\"isPlanChange\",\"isPlanDowngrade\",\"isSocialSetDowngrade\",\"isUserDowngrade\",\"effectiveDate\",\"aiCreditsEffectiveDate\",\"intervalEffectiveDate\",\"planEffectiveDate\",\"socialSetEffectiveDate\",\"userEffectiveDate\",\"amountEffectiveDate\",\"isLoading\",\"taxAmount\",\"taxRate\",\"proratedTaxAmount\"],[[30,0,[\"immediateAmount\"]],[30,0,[\"immediateAmountAfterTax\"]],[30,0,[\"futureAmount\"]],[30,0,[\"futureAmountAfterTax\"]],[30,0,[\"futureDate\"]],[30,0,[\"defaultFormat\"]],[30,0,[\"userChange\"]],[30,0,[\"socialSetChange\"]],[30,0,[\"aiCreditsChange\"]],[30,0,[\"isAiCreditsChange\"]],[30,0,[\"isAiCreditsDowngrade\"]],[30,0,[\"isUserChange\"]],[30,0,[\"isSocialSetChange\"]],[30,0,[\"isAmountChange\"]],[30,0,[\"isIntervalChange\"]],[30,0,[\"isIntervalDowngrade\"]],[30,0,[\"isMissingTaxData\"]],[30,0,[\"isPlanChange\"]],[30,0,[\"isPlanDowngrade\"]],[30,0,[\"isSocialSetDowngrade\"]],[30,0,[\"isUserDowngrade\"]],[30,0,[\"effectiveDate\"]],[30,0,[\"aiCreditsEffectiveDate\"]],[30,0,[\"intervalEffectiveDate\"]],[30,0,[\"planEffectiveDate\"]],[30,0,[\"socialSetEffectiveDate\"]],[30,0,[\"userEffectiveDate\"]],[30,0,[\"amountEffectiveDate\"]],[30,0,[\"calculateProration\",\"isRunning\"]],[30,0,[\"taxAmount\"]],[30,0,[\"taxRate\"]],[30,0,[\"proratedTaxAmount\"]]]]]]],[1,\"\\n\"],[13]],[\"@subscription\",\"@selectedSubscriptionPlan\",\"@additionalTeamMemberCount\",\"@additionalSocialSetCount\",\"@additionalAiCredits\",\"@couponId\",\"@savedAddress\",\"@cardCountry\",\"@hasTaxId\",\"&default\"],false,[\"did-insert\",\"perform\",\"did-update\",\"yield\",\"hash\"]]",
    "moduleName": "checkout/components/proration.hbs",
    "isStrictMode": false
  });
  let ProrationComponent = _exports.default = (_class = class ProrationComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "address", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "locale", _descriptor5, this);
      _initializerDefineProperty(this, "payment", _descriptor6, this);
      _initializerDefineProperty(this, "plans", _descriptor7, this);
      _defineProperty(this, "defaultFormat", 'MMM D, YYYY');
      _initializerDefineProperty(this, "prorationData", _descriptor8, this);
      _initializerDefineProperty(this, "taxData", _descriptor9, this);
      _defineProperty(this, "calculateProration", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function (element, _ref) {
          var _this = this;
          let [subscription, subscriptionPlan, additionalUsers, additionalSocialSets, additionalAiCredits, couponId, savedAddress, cardCountry, hasTaxId] = _ref;
          return function* () {
            if (!subscription?.id && !subscriptionPlan?.stripePlanId) {
              return;
            }

            // Debounce to avoid hitting this endpoint too frequently
            const debounceMs = false ? 1 : 1500;
            yield (0, _emberConcurrency.timeout)(debounceMs);
            try {
              if (_this.address.shouldDisplayTaxAmount && _this.address.isSavedAddressValid) {
                const customerDetails = {};
                if (savedAddress.verified) {
                  customerDetails.address = (0, _objectMethods.objectMap)((0, _objectMethods.objectFilter)(savedAddress, _ref2 => {
                    let [k] = _ref2;
                    return k !== 'verified';
                  }), _ref3 => {
                    let [key, value] = _ref3;
                    return [(0, _lodash.snakeCase)(key), value];
                  });
                } else if (cardCountry) {
                  customerDetails.address = {
                    country: _this.address.cardCountry
                  };
                }
                if (_this.args.taxId && hasTaxId) {
                  customerDetails.vat_number = _this.args.taxId;
                }
                _this.taxData = yield _this.payment.retrieveStripeTax({
                  stripePlanId: subscriptionPlan.stripePlanId,
                  additionalUsers,
                  additionalSocialSets,
                  additionalAiCredits,
                  customerDetails,
                  couponId
                });
              }
              if (subscription?.id) {
                const taxId = _this.args.taxId && hasTaxId ? _this.args.taxId : undefined;
                const couponId = _this.args.couponId ? _this.args.couponId : undefined;
                _this.prorationData = yield _this.payment.retrieveProration({
                  subscription,
                  stripePlanId: subscriptionPlan.stripePlanId,
                  additionalUsers,
                  additionalSocialSets,
                  additionalAiCredits,
                  taxId,
                  couponId
                });
              }
            } catch (error) {
              _this.errors.log(error, {
                subscriptionId: subscription?.id,
                stripePlanId: subscriptionPlan.stripePlanId,
                additionalUsers,
                additionalSocialSets,
                additionalAiCredits
              });
            }
          }();
        }
      }), null, "calculateProration", "restartable"));
    }
    get additionalMigratedSocialSets() {
      return this.hasMigratedSocialSetsAddons ? this.args.selectedSubscriptionPlan.numberOfSocialSets - this.args.subscription.includedSocialSets : 0;
    }
    get additionalMigratedUsers() {
      return this.hasMigratedUserAddons ? this.args.selectedSubscriptionPlan.numberOfUsers - this.args.subscription.includedUsers : 0;
    }
    get immediateAmount() {
      if (!this.args.subscription?.id) {
        return this.futureAmount;
      } else if (this.prorationData?.immediate_amount <= 0) {
        return 0;
      }
      return this.prorationData?.immediate_amount;
    }

    /**
     * Formats futureAmount and adds 'plus applicable taxes' .
     * When we have the actual tax included, we can replace this with the actual amount.
     */
    get immediateAmountAfterTax() {
      if (this.address.shouldDisplayTaxAmount) {
        return this.locale.formatCurrency((((this.immediateAmount ?? 0) + this.proratedTaxAmount) / 100).toFixed(2));
      }
      const amount = this.locale.formatCurrency(((this.immediateAmount ?? 0) / 100).toFixed(2));
      if (!this.immediateAmount) {
        return amount;
      }
      return this.intl.t('plans.checkout.plan.amount_plus_tax', {
        amount
      });
    }
    get isOnLegacyPlan() {
      return this.auth.currentAccount?.isOnLegacyPlan;
    }
    get futureAmount() {
      return this.args.totalCost;
    }

    /**
     * Formats futureAmount and adds 'plus applicable taxes' .
     * When we have the actual tax included, we can replace this with the actual amount.
     */
    get futureAmountAfterTax() {
      if (this.address.shouldDisplayTaxAmount) {
        return this.locale.formatCurrency((((this.futureAmount ?? 0) + this.taxAmount) / 100).toFixed(2));
      }
      const amount = this.locale.formatCurrency(((this.futureAmount ?? 0) / 100).toFixed(2));
      return this.intl.t('plans.checkout.plan.amount_plus_tax', {
        amount
      });
    }
    get hasMigratedSocialSetsAddons() {
      return this.isOnLegacyPlan && this.args.subscription.totalSocialSets > this.args.selectedSubscriptionPlan.numberOfSocialSets;
    }
    get hasMigratedUserAddons() {
      return this.isOnLegacyPlan && this.args.subscription.totalUsers > this.args.selectedSubscriptionPlan.numberOfUsers;
    }
    get aiCreditsChange() {
      return this.args.additionalAiCredits - this.args.initialAiCreditsCount;
    }
    get socialSetChange() {
      return this.args.additionalSocialSetCount + this.additionalMigratedSocialSets - this.args.initialSocialSetCount;
    }
    get userChange() {
      return this.args.additionalTeamMemberCount + this.additionalMigratedUsers - this.args.initialTeamMemberCount;
    }
    get isAiCreditsChange() {
      return this.aiCreditsChange !== 0;
    }
    get isSocialSetChange() {
      return this.socialSetChange !== 0;
    }
    get isUserChange() {
      return this.userChange !== 0;
    }
    get isIntervalChange() {
      return this.args.currentSubscriptionPlan?.normalizedInterval !== this.args.selectedSubscriptionPlan?.normalizedInterval;
    }
    get isPlanChange() {
      return this.args.currentSubscriptionPlan?.name !== this.args.selectedSubscriptionPlan?.name;
    }
    get isAmountChange() {
      return this.args.subscription?.amountInCents != this.futureAmount;
    }
    get isIntervalDowngrade() {
      return this.args.currentSubscriptionPlan.isYearly && this.args.selectedSubscriptionPlan.isMonthly;
    }
    get isAiCreditsDowngrade() {
      return this.aiCreditsChange < 0;
    }
    get isSocialSetDowngrade() {
      return this.socialSetChange < 0;
    }
    get isUserDowngrade() {
      return this.userChange < 0;
    }
    get futureDate() {
      if (this.auth.currentAccount.hasActiveTrial || this.auth.currentAccount.canTrialPlan) {
        return this.auth.currentAccount.trialExpiryMoment || (0, _moment.default)().add(14, 'days');
      }
      if (this.prorationData.future_amount_time) {
        return _moment.default.unix(this.prorationData.future_amount_time);
      }
      if (this.args.subscription?.billingPeriodEndTime) {
        return _moment.default.unix(this.args.subscription.billingPeriodEndTime);
      }

      // Note: finally handles users on free, with no paid subscription
      return (0, _moment.default)();
    }
    get isPlanDowngrade() {
      if (this.args.selectedSubscriptionPlan?.isAgencyPlan) {
        return this.args.currentSubscriptionPlan?.isAgency30Plan && this.args.selectedSubscriptionPlan?.isAgency15Plan;
      }
      return this.args.currentSubscriptionPlan && this.args.selectedSubscriptionPlan && (0, _upgradeDowngrade.isDowngrade)(this.args.currentSubscriptionPlan, this.args.selectedSubscriptionPlan, this.plans.plans);
    }
    get effectiveDate() {
      return this._buildEffectiveDate(this._hasAnyDowngrade);
    }
    get intervalEffectiveDate() {
      return this._buildEffectiveDate(this.isIntervalDowngrade);
    }
    get planEffectiveDate() {
      const isBillingDowngrade = this.isPlanDowngrade || this.isIntervalDowngrade;
      return this._buildEffectiveDate(isBillingDowngrade);
    }
    get aiCreditsEffectiveDate() {
      return this._buildEffectiveDate(this.isAiCreditsDowngrade);
    }
    get socialSetEffectiveDate() {
      return this._buildEffectiveDate(this.isSocialSetDowngrade);
    }
    get userEffectiveDate() {
      return this._buildEffectiveDate(this.isUserDowngrade);
    }
    get amountEffectiveDate() {
      return this._buildEffectiveDate(this._hasAnyDowngrade);
    }
    get isMissingTaxData() {
      return (0, _lodash.isEmpty)(this.taxData);
    }
    get taxAmount() {
      return this.taxData?.tax ?? 0;
    }
    get taxRate() {
      if (this.taxData.total_tax_amounts?.[0]?.tax_rate?.percentage) {
        return this.taxData.total_tax_amounts[0]?.tax_rate?.percentage;
      }
      return 0;
    }
    get proratedTaxAmount() {
      // Note: if no subscription exists, the immediate amount is the same as the monthly total
      if (!this.args.subscription?.id) {
        return this.taxAmount;
      }
      return this.prorationData?.taxes ?? 0;
    }
    get _hasAnyDowngrade() {
      return this.isUserDowngrade || this.isSocialSetDowngrade || this.isPlanDowngrade || this.isIntervalDowngrade;
    }
    _buildEffectiveDate(isDowngrade) {
      if (isDowngrade && !this.prorationData?.future_amount_time) {
        return this.intl.t('plans.checkout.charges.loading');
      }
      return isDowngrade ? this.futureDate.format(this.defaultFormat) : this.intl.t('plans.checkout.charges.immediate');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "prorationData", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {};
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "taxData", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {};
    }
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProrationComponent);
});